/* eslint-disable no-unreachable */
import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  DialogTitle,
  Snackbar,
  Alert,
  LinearProgress,
  FormControl,
  DialogContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  Switch,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Label } from 'reactstrap';
import axios from '../../axiosConfig';
import { ReactComponent as Dashboard } from '../../media/dashboard2.svg';
import { ReactComponent as Ops } from '../../media/opsss.svg';
import { ReactComponent as ManageIcon } from '../../media/obm.svg';
import { ReactComponent as MastersIcon } from '../../media/pd.svg';
import { ReactComponent as ReportsIcon } from '../../media/prrd.svg';
import './UserPrivileges.css';
import './animation.css';

const SwitchContainer = ({ children }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    spacing={2}
    py={2}
    px={2}
    mb={2}
    elevation={3}
    component={Paper}
    sx={{ backgroundColor: 'inherit ' }}
  >
    {children}
  </Stack>
);


const ControlCenter = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [openAlert, setOpenAlert] = useState(false);
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [expanded, setExpanded] = React.useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState(null);
  const [daywiseEntry, setDaywiseEntry] = useState(false);
  const [obProduction, setObProduction] = useState(false)
  const [dupEmpinDailyProd, setDupEmpinDailyProd] = useState(false)

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenAlert(false); // ✅ must reset
  };

  const showAlert = (message, type = "success") => {
    setAlertMessage(message);
    setAlertType(type);
    setOpenAlert(false); // reset first
    setTimeout(() => setOpenAlert(true), 0); // ✅ ensure toggle
  };

  // API Integration
  useEffect(() => {
    GetAllActiveProductionUnits();
  }, []);

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllProductionUnits', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const data = res.data.filter(d => d.Active === 'Y' && d.CompanyId===sessionStorage.getItem('CompanyId'));
      setUnitData(data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const InsertControlCenter = async () => {
    if (unitSelected === null) {
      showAlert("Select any unit", "warning")
      return
    }
    setOpenLoader(true);
    try {
      const res = await axios.instance.post('/InsertControlCenter', {
        CompanyId: sessionStorage.getItem('CompanyId'),
        FactoryId: unitSelected.Unit_Id,
        DaywiseEntry: daywiseEntry ? 'Y' : 'N',
        OBProduction : obProduction ? 'Y' : 'N',
        DuplicateEmpinDailyProd : dupEmpinDailyProd ? 'Y' : 'N',
      }, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      if (res.status === 200) {
        showAlert("Updated Successfully", "success")
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setOpenLoader(false);
  }

  const GetOneControl = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneControlCenter/${id}/${sessionStorage.getItem('CompanyId')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      if (res.data.length > 0) {
        res.data.forEach(data => {
          setDaywiseEntry(data.DaywiseEntry === 'Y');
          setObProduction(data.OBProduction === 'Y');
          setDupEmpinDailyProd(data.DuplicateEmpinDailyProd === 'Y');
        });
      } else {
        setDaywiseEntry(false);
        setObProduction(false)
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <>
    <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Control Center
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
          <Grid item xs={12} md={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <Autocomplete
                size="small"
                fullWidth
                options={unitData}
                getOptionLabel={(obj) => obj.Unit_Name}
                isOptionEqualToValue={(option, value) => option.Unit_Name === value.Unit_Name}
                renderInput={(params) => <TextField {...params} label="Unit" />}
                value={unitSelected}
                onChange={(e, newValue) => {
                  setUnitSelected(newValue);
                  if(newValue) GetOneControl(newValue.Unit_Id)
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
              <Accordion
                expanded={expanded}
                disableGutters
                sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={handleExpansion} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  sx={{ borderTop: 'none' }}
                >
                  <Stack
                    justifyContent={'space-between'}
                    direction={'row'}
                    alignItems={'center'}
                    p={0}
                    m={0}
                    pr={2}
                    width={'100%'}
                  >
                    <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                      <IconButton aria-label="ExpandMoreIcon" color="white">
                        <Dashboard style={{ color: 'white', width: 24, height: 24 }} />
                      </IconButton>
                      <Typography
                        sx={{
                          color: '#36BA98',
                          '&.active': {
                            color: 'text.primary',
                            bgcolor: 'action.selected',
                            fontWeight: 'fontWeightBold',
                          },
                        }}
                        variant="h6"
                      >
                        Daily Production
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>

                <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                    <Grid item xs={12}>
                      <SwitchContainer>
                        <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                          Daywise Entry
                        </Label>
                        <input
                          id={`daywise_entry`}
                          className="checkbox2"
                          type="checkbox"
                          checked={daywiseEntry}
                          onClick={(e) => {
                            setDaywiseEntry(e.target.checked);
                          }}
                        />
                      </SwitchContainer>
                    </Grid>
                      <Grid item xs={12}>
                      <SwitchContainer>
                        <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                          OB Production
                        </Label>
                        <input
                          id={`daywise_entry`}
                          className="checkbox2"
                          type="checkbox"
                          checked={obProduction}
                          onClick={(e) => {
                            setObProduction(e.target.checked);
                          }}
                        />
                      </SwitchContainer>
                    </Grid>
                    <Grid item xs={12}>
                      <SwitchContainer>
                        <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                          Duplicate Employee Allow In Daily Production
                        </Label>
                        <input
                          id={`daywise_entry`}
                          className="checkbox2"
                          type="checkbox"
                          checked={dupEmpinDailyProd}
                          onClick={(e) => {
                            setDupEmpinDailyProd(e.target.checked);
                          }}
                        />
                      </SwitchContainer>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2} my={2}>
              <Button
                variant="contained"
                color="success"
                sx={{ boxShadow: 1, backgroundColor: '#36BA98', color: 'white' }}
                onClick={InsertControlCenter}
              >
                Save
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default ControlCenter;
